import React, { useState, useEffect } from "react";
import "./Nav.css";

function Nav() {


  const [show, handleShow] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        handleShow(true);
      } else handleShow(false);
    });
    return () => {
      window.removeEventListener("scroll");
    };
  }, []);

    return (
      <div className={`nav ${show && "nav__black"}`}>
        <img
          className="nav__logo"
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/799px-Netflix_2015_logo.svg.png"
          alt="Netflix
        Logo"
        />
        <img
          className="nav__avatar"
          src="https://th.bing.com/th/id/OIP.Fn_JfIeC12rS1weLLJxdyQHaHa?w=212&h=212&c=7&r=0&o=5&dpr=1.5&pid=1.7"
          alt="Netflix
        Logo"
        />
      </div>
    );
}

export default Nav;
